import { render, staticRenderFns } from "./MiniProgramNav.vue?vue&type=template&id=efd60492&scoped=true"
import script from "./MiniProgramNav.vue?vue&type=script&lang=js"
export * from "./MiniProgramNav.vue?vue&type=script&lang=js"
import style0 from "./MiniProgramNav.vue?vue&type=style&index=0&id=efd60492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd60492",
  null
  
)

export default component.exports